import { c as _c } from "react/compiler-runtime";
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import useEntityVault from '@/entities/hooks/use-entity-vault';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import useDocumentField from '@/entity/hooks/use-document-field';
import useOnboardingDocuments from './use-onboarding-documents';

/** "Decrypt all" for the documents uploaded during an onboarding. */
const useDecryptOnboardingDocuments = (entity, onboarding) => {
  const $ = _c(25);
  const {
    documents,
    isPending
  } = useOnboardingDocuments(entity, onboarding);
  let t0;
  if ($[0] !== entity.id) {
    t0 = {
      entityId: entity.id
    };
    $[0] = entity.id;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: vaultData,
    update: onDecryptSuccess
  } = useEntityVault(t0);
  let t1;
  if ($[2] !== entity) {
    t1 = {
      entity
    };
    $[2] = entity;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    getProps,
    getRelatedDisByFormValue
  } = useDocumentField(t1);
  const decryptControls = useDecryptControls();
  let decryptable;
  let fields;
  let pending;
  let t2;
  if ($[4] !== decryptControls || $[5] !== documents || $[6] !== getProps || $[7] !== getRelatedDisByFormValue || $[8] !== vaultData) {
    pending = vaultData && documents ? documents.filter(document => getRelatedDisByFormValue(document).length > 0 && !getProps(document).isDecrypted) : [];
    decryptable = pending.filter(_temp);
    fields = [...new Set(decryptable.flatMap(getRelatedDisByFormValue))];
    t2 = decryptControls.isDecrypting(fields);
    $[4] = decryptControls;
    $[5] = documents;
    $[6] = getProps;
    $[7] = getRelatedDisByFormValue;
    $[8] = vaultData;
    $[9] = decryptable;
    $[10] = fields;
    $[11] = pending;
    $[12] = t2;
  } else {
    decryptable = $[9];
    fields = $[10];
    pending = $[11];
    t2 = $[12];
  }
  const isDecrypting = t2;
  let t3;
  if ($[13] !== decryptControls || $[14] !== entity || $[15] !== fields || $[16] !== onDecryptSuccess || $[17] !== onboarding) {
    t3 = async () => {
      if (!fields.length) {
        return;
      }
      const response = await decryptControls.decrypt({
        entity,
        fields,
        reason: `Examining documents for onboarding ${onboarding.id}`
      });
      if (response) {
        onDecryptSuccess({
          vault: response,
          transforms: {},
          dataKinds: {}
        });
      }
    };
    $[13] = decryptControls;
    $[14] = entity;
    $[15] = fields;
    $[16] = onDecryptSuccess;
    $[17] = onboarding;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  const decrypt = t3;
  const t4 = pending.length > 0;
  const t5 = decryptable.length > 0;
  let t6;
  if ($[19] !== decrypt || $[20] !== isDecrypting || $[21] !== isPending || $[22] !== t4 || $[23] !== t5) {
    t6 = {
      decrypt,
      isDecrypting,
      isPending,
      hasEncryptedDocuments: t4,
      canDecrypt: t5
    };
    $[19] = decrypt;
    $[20] = isDecrypting;
    $[21] = isPending;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
export default useDecryptOnboardingDocuments;
function _temp(document_0) {
  return document_0.canDecrypt;
}